import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { FOCUSABLE_TAB_INDEX, NON_FOCUSABLE_TAB_INDEX } from 'utils/constants';
import styles from './DropdownOptions.module.scss';

export interface SelectOption {
  value: string;
  label: string;
  fullName?: string;
}

interface DropdownOptionsProps {
  options: SelectOption[];
  isOpen: boolean;
  onMouseUp: (value: string) => void;
  optionsActive: boolean;
  searchable: boolean;
  dropdownListId?: string;
  selectedOptionValue?: string;
}

const DropdownOptions = forwardRef(
  (props: DropdownOptionsProps, ref: React.ForwardedRef<HTMLUListElement>) => {
    const {
      options,
      isOpen,
      onMouseUp,
      optionsActive,
      searchable,
      dropdownListId,
      selectedOptionValue,
    } = props;

    return (
      <div
        className={isOpen ? styles.optionsListContainerOpened : styles.optionsListContainer}
        aria-hidden={!isOpen}
      >
        {!!options.length ? (
          <ul
            className={styles.optionsList}
            ref={ref}
            role="listbox"
            id={dropdownListId}
            tabIndex={NON_FOCUSABLE_TAB_INDEX}
          >
            {options.map((item) => (
              <li
                role="option"
                id={`${dropdownListId}-${item.value}`}
                aria-selected={item.value === selectedOptionValue}
                key={`${dropdownListId}-${item.value}`}
                onMouseUp={() => onMouseUp(item.value)}
                onMouseDown={(e) => {
                  e.preventDefault();
                }}
                className={styles.option}
                tabIndex={optionsActive ? FOCUSABLE_TAB_INDEX : NON_FOCUSABLE_TAB_INDEX}
                {...(item.fullName ? { 'aria-label': item.fullName } : {})}
              >
                {item.label}
              </li>
            ))}
          </ul>
        ) : (
          searchable && <p className={clsx(styles.optionsList, styles.noOptions)}>No options</p>
        )}
      </div>
    );
  },
);

export default DropdownOptions;
